<template>
    <div id="ProfessionalMembershipSection">
        <div class="card">
            <div class="card-body">
                <div class="d-flex align-items-center mb-4">
                    <h5 class="card-title flex-grow-1 mb-0">Professional Memberships</h5>
                    <div class="flex-shrink-0">
                        <button @click="formContext.modal = true" class="btn btn-primary" type="button">
                            Add <span class="d-none d-sm-inline">Membership</span>
                        </button>
                    </div>
                </div>
                <CommonSpinner v-if="isLoading" />
                <div v-else class="row g-4">
                    <div v-for="(data, index) in pageData.data" :key="index" class="col-lg-6">
                        <div class="card border mb-0">
                            <div class="card-body p-3">
                                <div class="d-flex justify-content-between">
                                    <div>
                                        <h5 class="mb-1">{{ data.professional_body_title }}</h5>
                                        <p class="mb-1" v-if="data.membership_grade_title">
                                            <strong>Grade:</strong> {{ data.membership_grade_title }}
                                        </p>
                                        <p class="mb-1" v-if="data.membership_number">
                                            <strong>Membership No:</strong> {{ data.membership_number }}
                                        </p>
                                        <p class="mb-0" v-if="data.date_admitted">
                                            <strong>Date Admitted:</strong>
                                            {{ $filters.date(data.date_admitted) }}
                                        </p>
                                    </div>
                                    <div class="dropdown dropstart no-arrow">
                                        <button class="dropdown-toggle btn btn-sm rounded-circle btn-primary" type="button" data-bs-toggle="dropdown">
                                            <i class="ri-more-2-fill"></i>
                                        </button>
                                        <ul class="dropdown-menu">
                                            <li>
                                                <button @click.prevent="openEditView(data)" class="dropdown-item">
                                                    Edit
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <p v-if="!pageData.data.length">No professional membership added.</p>
                </div>
            </div>
        </div>

        <b-modal
            v-model="formContext.modal" size="lg" centered hide-footer title-class="fs-6"
            :title="formContext.editMode ? 'Update Professional Membership' : 'Add Professional Membership'"
            @hide="closeEditView()">
            <membership-form
                v-if="formContext.modal"
                :edit-mode="formContext.editMode"
                :edit-item="formContext.item"
                @closeMe="closeEditView()"
                @addedItem="addItem"
                @updatedItem="updateItem"/>
        </b-modal>
    </div>
</template>

<script>
import MembershipForm from "@/components/forms/MembershipForm.vue";
import { commonEditViewMixin } from "@/mixins/commonEditViewMixin";
import { commonPaginationMixin } from '@/mixins/commonPaginationMixin';

export default {
    components:{
        MembershipForm
    },
    mixins:[
        commonEditViewMixin,
        commonPaginationMixin
    ],
    data(){
        return{
            isLoading:false,
        }
    },
    methods:{
        addItem(item){
            this.pageData.data.unshift(item);
        },
        updateItem(item){
            const index = this.pageData.data.findIndex(i=>i.id==item.id);
            Object.assign(this.pageData.data[index],item);
        },
        fetchItems(){
            this.isLoading=true;
            this.$http.get("/memberships")
            .then(response => {
                this.isLoading = false;
                if(response.data.success){
                    this.pageData = response.data.data;
                }
            });
        }
    },
    created(){
        this.fetchItems();
    }
}
</script>